import React, { useState } from 'react';
import { Box, BoxProps } from '@mui/material';

interface Props extends BoxProps {
  src: string;
  alt?: string;
  height?: number;
  fallback?: () => JSX.Element | null;
}

export const Image = React.forwardRef(({ fallback = () => null, height, ...props }: Props, ref) => {
  const [hasError, setHasError] = useState(false);
  if (hasError) {
    return fallback();
  }

  return (
    <Box
      height={height || '30px'}
      component="img"
      onError={() => {
        setHasError(true);
      }}
      ref={ref}
      {...props}
    />
  );
});
